// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"AllocationBreakdown_tableContainer__21b7C"};